var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61548 0.692307H27.4614V22.846H1.61548V0.692307Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61548 0.692307H27.4614V22.846H1.61548V0.692307Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1069 10.1999C24.2415 9.41531 24.193 8.61224 23.9723 7.84148C23.6707 6.82148 23.0569 5.85688 22.1307 5.06304C21.1992 4.26458 20.0738 3.73843 18.8892 3.48459C17.99 3.29074 17.0531 3.2492 16.1377 3.3692",
    stroke: "#1E6BE5",
    strokeWidth: 1.61537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.02 9.8307C20.1653 8.9907 19.8584 8.10456 19.1046 7.4621C18.3507 6.81595 17.3169 6.55288 16.3369 6.67749",
    stroke: "#1E6BE5",
    strokeWidth: 1.61537,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.353 4.74919C9.74069 4.74919 10.1015 4.92919 10.2899 5.21995L11.6038 7.25071C11.7761 7.51378 11.7814 7.83686 11.6253 8.10916L10.3545 10.283C10.3545 10.283 10.7207 11.903 12.2607 13.2184C13.7953 14.5337 15.6799 14.843 15.6799 14.843L18.216 13.7537C18.5337 13.6153 18.9052 13.6199 19.2175 13.7722L21.5921 14.903C21.9314 15.0645 22.1414 15.3737 22.1414 15.706V18.046C22.1414 19.2368 20.8491 20.0952 19.5298 19.7168C16.8214 18.9322 12.6161 17.4414 9.95607 15.1568C7.29071 12.8722 5.55149 9.26762 4.63611 6.95071C4.18919 5.81995 5.19611 4.71227 6.58533 4.71227H9.31531L9.353 4.74919Z",
    stroke: "#1E6BE5",
    strokeWidth: 1.61537,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/iconPhone.4379db1fbd82c35e58ed6fb6ceda6da3.svg";
export { ForwardRef as ReactComponent };